import { ACCOUNT_WITHDRAW_FUNDS_MAX_AMOUNT, ACCOUNT_WITHDRAW_FUNDS_MIN_AMOUNT, ACCOUNT_WITHDRAW_FUNDS_QIWI_MIN_AMOUNT, ACCOUNT_WITHDRAW_FUNDS_RUS_BANK_CARD_MIN_AMOUNT, ACCOUNT_WITHDRAW_FUNDS_UKR_BANK_CARD_MIN_AMOUNT } from '@config/account';
import { ERROR_CODE } from '@config/errors';
import { findById } from '@helpers/data';
import { ValidationRules } from '@validation/validator';
import { SPECIALIST_WALLET_TYPE, SpecialistWallets } from '@types';
import { AccountWithdrawFundsFormData } from '@forms/account/account-withdraw-funds';
export const accountWithdrawFundsValidationRules = (balanceAmount: number, wallets: undefined | SpecialistWallets): ValidationRules => {
  return {
    amount: (amount: string, attributes: AccountWithdrawFundsFormData) => {
      const {
        walletId
      } = attributes;
      const withdrawalAmount = parseFloat(amount);
      const selectedWallet = findById(wallets ?? [], walletId);
      const walletType = selectedWallet?.type;
      const presence = {
        allowEmpty: false,
        message: ERROR_CODE.WITHDRAW_ENTER_AMOUNT
      };
      if (walletType === SPECIALIST_WALLET_TYPE.UKR_BANK_CARD && withdrawalAmount < ACCOUNT_WITHDRAW_FUNDS_UKR_BANK_CARD_MIN_AMOUNT) {
        return {
          numericality: {
            onlyInteger: true,
            greaterThanOrEqualTo: ACCOUNT_WITHDRAW_FUNDS_UKR_BANK_CARD_MIN_AMOUNT,
            lessThanOrEqualTo: ACCOUNT_WITHDRAW_FUNDS_MAX_AMOUNT,
            message: ERROR_CODE.WITHDRAW_MONEY_UKR_BANK_CARD_MIN_LIMIT_EXCEEDED
          },
          presence
        };
      }
      if (walletType === SPECIALIST_WALLET_TYPE.RUS_BANK_CARD && withdrawalAmount < ACCOUNT_WITHDRAW_FUNDS_RUS_BANK_CARD_MIN_AMOUNT) {
        return {
          numericality: {
            onlyInteger: true,
            greaterThanOrEqualTo: ACCOUNT_WITHDRAW_FUNDS_RUS_BANK_CARD_MIN_AMOUNT,
            lessThanOrEqualTo: ACCOUNT_WITHDRAW_FUNDS_MAX_AMOUNT,
            message: ERROR_CODE.WITHDRAW_MONEY_RUS_BANK_CARD_MIN_LIMIT_EXCEEDED
          },
          presence
        };
      }
      if (walletType === SPECIALIST_WALLET_TYPE.QIWI && withdrawalAmount < ACCOUNT_WITHDRAW_FUNDS_QIWI_MIN_AMOUNT) {
        return {
          numericality: {
            onlyInteger: true,
            greaterThanOrEqualTo: ACCOUNT_WITHDRAW_FUNDS_QIWI_MIN_AMOUNT,
            lessThanOrEqualTo: ACCOUNT_WITHDRAW_FUNDS_MAX_AMOUNT,
            message: ERROR_CODE.WITHDRAW_MONEY_QIWI_MIN_LIMIT_EXCEEDED
          },
          presence
        };
      }
      if (withdrawalAmount < ACCOUNT_WITHDRAW_FUNDS_MIN_AMOUNT) {
        return {
          numericality: {
            onlyInteger: true,
            greaterThanOrEqualTo: ACCOUNT_WITHDRAW_FUNDS_QIWI_MIN_AMOUNT,
            lessThanOrEqualTo: ACCOUNT_WITHDRAW_FUNDS_MAX_AMOUNT,
            message: ERROR_CODE.WITHDRAW_MONEY_BALANCE_AMOUNT_EXCEEDED
          },
          presence
        };
      }
      if (withdrawalAmount > balanceAmount && withdrawalAmount <= ACCOUNT_WITHDRAW_FUNDS_MAX_AMOUNT) {
        return {
          numericality: {
            onlyInteger: true,
            greaterThanOrEqualTo: ACCOUNT_WITHDRAW_FUNDS_QIWI_MIN_AMOUNT,
            lessThanOrEqualTo: balanceAmount,
            message: ERROR_CODE.WITHDRAW_MONEY_BALANCE_AMOUNT_EXCEEDED
          },
          presence
        };
      }
      return {
        numericality: {
          onlyInteger: true,
          greaterThanOrEqualTo: ACCOUNT_WITHDRAW_FUNDS_QIWI_MIN_AMOUNT,
          lessThanOrEqualTo: ACCOUNT_WITHDRAW_FUNDS_MAX_AMOUNT,
          message: ERROR_CODE.WITHDRAW_MONEY_MAX_LIMIT_EXCEEDED
        },
        presence
      };
    },
    walletId: {
      presence: {
        allowEmpty: false
      }
    }
  };
};